<template>
 <v-container>
  <v-card>
    <v-container>
      <h1>About Page</h1>
      <p>This is a pilot product to track who is on/off site at any given time using the Bluetooth Identification cards</p>
      <h2>How to use</h2>
      <p>The application is currently set up to detect bluetooth cards at 3 locations</p>
      <img src="@/assets/siteplan.png" style="width: 100%; max-width: 500px"/>
      <ul>
        <li><p>A reading at gate 1 will tell the software that the employee is offsite</p></li>
        <li><p>A reading at gate 2 will tell the software that the employee is onsite via gate2 (Entry gate)</p></li>
        <li><p>A reading at gate 3 will tell the software that the employee is onsite via gate3 (Alley)</p></li>
      </ul>
      <h3>Logging in</h3>
      <p>There is currently no registration page to sign up, any new users will need to email <a href="mailto:jarrod@digital-efficiency.co.nz">Jarrod</a> with the email they will use to sign in and password so they can be added</p>
      <h3>Main Page</h3>
      <p>This shows employee in/out traffic for the current day only</p>
      <h3>Users</h3>
      <p>This shows all employees currently registered with the application and what card they have.</p>
      <h3>User Log</h3>
      <p>This is a log of all events. You can filter by employee and date</p>
      <h2>How to give feedback and report bugs</h2>
      <p>To provide feedback please email Jarrod and Paul (contact details below). When emailing please provide as much information as possible.</p>
      <h5>Bugs</h5>
      <p>A screenshot and details on what you were doing leading up to the bug happening will help in addressing the problem</p>
      <h5>Feature request</h5>
      <p>If its simple enough for then a description or drawing of what you want to achieve, otherwise we will meet onsite to discuss</p>
      <v-divider></v-divider>
      <v-layout column>
        <h2>Contact us</h2>
        <v-flex v-for="(contact, index) in contacts" :key="index" class="my-2">
          <h3>{{contact.name}}</h3>
          <h4>m: <a :href="'mailto:' + contact.email">{{contact.email}}</a></h4>
          <h4>p: <a :href="'tel:' + contact.phone">{{contact.phone}}</a></h4>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      contacts: [
        {name: 'Jarrod Lodge', email: 'jarrod@limedigital.nz', phone: '+64211352853'},
        {name: 'Paul Plester', email: 'paul.plester@rfdsl.co.nz', phone: '+64278633513'}
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/About.vue